export default function getStyles({ palette }) {
    return {
        authTabContainer: {
            display: 'flex',
            flexDirection: 'column',
            // height: '72vh',
            // maxHeight: '72vh',
            height: '100%',
            boxSizing: 'border-box',
            // marginTop: '36px',
            // ml: '-16px', // this has to be removed & a proper fix should be applied to other tabs
            // mr: '-24px',
            borderRadius: '8px',
            direction: 'row',
            justifyContent: 'space-between',
            backgroundColor: palette.background.backgroundBlue,
        },
    };
}

export const EditFlowStyles = {
    pageTitle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' },
};
